import { ShippingMethod } from '@liveauctioneers/hammer-ui-payments/types';
import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppSelector } from '@/redux/hooks';
import { getDeployment } from '@/redux/modules/config';
import { track } from '@/utils/amplitude/analytics/core';
import { TrackingEvents, TrackingPayload } from '@/utils/amplitude/analytics/core.types';
import { getFullUrl } from '@/utils/amplitude/analytics/utils/getFullUrl';
import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';

type PayNowClickedUniquePayload = {
    shippingMethod: ShippingMethod;
};

type PayNowClickedPayload = TrackingPayload & PayNowClickedUniquePayload;

const trackPayNowClicked = (payload: PayNowClickedPayload) => {
    track(TrackingEvents.Checkout.PayNowClicked, payload);
};

export const useTrackPayNowClicked = () => {
    const deployment = useAppSelector(getDeployment);
    const { pathname } = useLocation();

    return useCallback(
        ({ shippingMethod }: PayNowClickedUniquePayload) => {
            trackPayNowClicked({
                pageName: getAmplitudePageNameFromPath(pathname),
                shippingMethod,
                url: getFullUrl(deployment, pathname),
            });
        },
        [deployment, pathname]
    );
};
